/**
 * Saves the cart's business fields (snippets/tc-cart-vat.liquid) as cart
 * attributes, which Shopify copies onto the order for the invoice.
 *
 * Listens on the document rather than the inputs: the cart drawer is
 * re-rendered from the server after every change, which would drop listeners
 * attached to the old fields.
 */
(function () {
  'use strict';
  if (window.__tcCartVat) return;
  window.__tcCartVat = true;

  var timer = null;
  var pending = {};

  function flush() {
    var attributes = pending;
    pending = {};
    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
    }).catch(function () { /* the next change tries again */ });
  }

  document.addEventListener('input', function (e) {
    var field = e.target && e.target.closest && e.target.closest('[data-tc-cart-attr]');
    if (!field) return;
    var value = field.value.trim();
    if (field.getAttribute('data-tc-cart-attr') === 'VAT number') value = value.toUpperCase().replace(/\s+/g, '');
    pending[field.getAttribute('data-tc-cart-attr')] = value;
    clearTimeout(timer);
    timer = setTimeout(flush, 600);
  });
})();
